import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { faSignInAlt, faSignOutAlt, faTachometerAlt, faUser, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '@services/auth/auth.service';
import { HeaderData } from '@app/services/settings/models/settings-response';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { MenuItem } from '../navigation-bar/menu-items';
@Component({
  selector: 'app-mobile-menu',
  styleUrls: ['./mobile-menu.component.scss'],
  templateUrl: './mobile-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLinkActive, RouterLink, NgbCollapse, FontAwesomeModule],
})
export class MobileMenuComponent {
  auth = inject(AuthService);
  loginIcon = faSignInAlt;
  logoutIcon = faSignOutAlt;
  signUpIcon = faUserPlus;
  userIcon = faUser;
  dashboardIcon = faTachometerAlt;
  isCollapsed = true;

  headerData = input.required<HeaderData>();
  showProposals = input.required<boolean>();
  parsedMenu = input.required<MenuItem[]>();
  closeMenuEvent = output<void>();


  closeMenu() {
    this.closeMenuEvent.emit();
  }
}
